export default {
  model: {
    eventCategory: '活动分类',
    hotWord: '热搜词汇',
    message: '询价留言',
    topic: '话题',
    post: '帖子',
    eventBooking: '活动报名',
    product: '酒品',
    productRating: '酒品评级',
    member: '会员',
    provenance: '产区',
    country: '国家',
    province: '省份',
    city: '城市',
    merchantCategory: '酒庄分类',
    adminUsersRole: '管理员',
    adminUser: '管理员',
    role: '角色',
    user: '用户',
    banner: '轮播图',
    application: '应用管理',
    page: '页面',
    appConfig: '应用配置',
    setting: '平台设置',
    productCategory: '酒品分类',
    merchant: '酒庄',
    question: '问卷',
    option: '选项',
    customPage: '自定义页面',
    activeStorageBlob: '资源',
    actsAsTaggableOnTag: '标签',
  },
  eventCategory: {
    applicationId: '应用ID',
    name: '名称',
    application: '应用管理',
  },
  hotWord: {
    name: '名称',
    position: '优先级',
    applicationId: '应用ID',
  },
  message: {
    content: '内容',
    productId: '酒品ID',
    userId: 'User',
    isRead: '是否已读',
    product: '酒品',
    user: '用户',
  },
  topic: {
    name: '名称',
    isTop: '是否置顶',
  },
  post: {
    title: '标题',
    likesCount: '喜欢数',
    publishedAt: '分布时间',
    miniProgramPath: '小程序路径',
    shareDesc: '分享描述',
    publisherType: '发布者类型',
    publisherId: 'Publisher',
    publisher: '发布者',
    shareImage: '分享图片',
    posterImage: '海报图片',
    infographic: '帖子内容',
    medium: '媒介',
    topics: 'Topics',
    topicIds: 'Topic ids',
    merchants: 'Merchants',
    merchantIds: 'Merchant ids',
    products: 'Products',
    productIds: 'Product ids',
  },
  eventBooking: {
    eventId: 'Event',
    userId: 'User',
    event: '活动',
    user: '用户',
  },
  product: {
    colourAndLustre: '色泽',
    drinkTemperature: '适饮温度',
    enName: '英文名称',
    name: '名称',
    alcoholContent: '酒精浓度',
    merchantId: 'Merchant',
    productCategoryId: 'Product category',
    productRatingId: 'Product rating',
    likesCount: '喜欢数',
    miniProgramPath: '小程序路径',
    shareDesc: '分享描述',
    mainImage: '图片',
    merchant: '酒庄',
    productCategory: '酒品分类',
    productRating: '酒品评级',
    description: '产品介绍',
    tastingNotes: '品酒笔记',
    shareImage: '分享图片',
    posterImage: '海报图片',
    backgroundImage: '背景图',
  },
  productRating: {
    name: '名称',
  },
  member: {
    email: '电子邮箱',
    name: '姓名',
    wechat: '微信',
    cityId: 'City',
    gender: '性别',
    genders: {
      male: 'Male',
      female: 'Female',
    },
    provinceId: 'Province',
    userId: 'User',
    userType: '会员类型',
    userTypes: {
      amateur: '爱好者',
      practitioner: '从业者',
    },
    birthYear: '出生年份',
    user: '用户',
    questionaire: '问卷',
    city: '城市',
    province: '省份',
  },
  provenance: {
    name: '名称',
    cityIds: 'City ids',
    cities: '城市',
  },
  country: {
    iso3: 'ISO3',
    name: '名称',
  },
  province: {
    name: '名称',
    countryId: 'Country',
    country: '国家',
  },
  city: {
    name: '名称',
    provinceId: 'Province',
    province: '省份',
  },
  merchantCategory: {
    name: '名称',
  },
  adminUsersRole: {
    roleId: '角色',
    adminUserId: 'Admin user',
    applicationId: '应用ID',
    merchantId: 'Merchant',
    role: '角色',
    application: '应用管理',
    merchant: '酒庄',
    adminUser: '管理员',
  },
  adminUser: {
    email: '邮箱',
    name: '姓名',
    phone: '手机号码',
  },
  role: {
    name: '名称',
    kind: '类型',
    kinds: {
      custom: 'Custom',
      super: 'Super',
      application: '应用管理',
      merchant: '酒庄',
    },
    customPermissions: '自定义权限',
  },
  user: {
    screenName: '名称',
    avatar: '头像',
    member: '会员',
  },
  banner: {
    target: '目标',
    position: '优先级',
    pagePosition: '页面位置',
    pagePositions: {
      event: '活动',
    },
    kind: '类型',
    kinds: {
      web_link: '网站链接',
      image: '纯图片',
      mp_link: '小程序链接',
    },
    alt: '图片描述',
    image: '图片',
  },
  application: {
    name: '名称',
    desc: '描述',
    shareDesc: '分享描述',
    shareTitle: '分享标题',
    expiredAt: '过期时间',
    wechatApplicationId: 'Wechat application',
    wechatOfficialAccountUrl: 'Wechat official account url',
    wechatApplication: '微信小程序',
    applicationAdminUsersRoleId: 'Application admin users role',
    shareImage: '分享图片',
    logo: 'Logo',
    homeTopLogo: 'Home top logo',
    homeBottomLeftLogo: 'Home bottom left logo',
    questionaireTopImage: 'Questionaire top image',
    questionaireBackgroundImage: 'Questionaire background image',
    personalCenterBackgroundImage: 'Personal center background image',
    myCardsBackgroundImage: 'My cards background image',
    authorizeState: 'Authorize state',
    creator: 'Creator',
    posterImage: '海报图片',
  },
  page: {
    slug: 'Slug',
    title: '标题',
    type: '类型',
    applicationId: '应用ID',
    status: '状态',
    statuses: {
      draft: '草稿',
      published: '发布',
    },
    viewsCount: '浏览数',
    miniProgramPath: '小程序路径',
    wxacode: '小程序码',
    content: '内容',
  },
  appConfig: {
    extJson: 'Ext json',
    applicationId: '应用ID',
  },
  setting: {
  },
  productCategory: {
    name: '名称',
  },
  merchant: {
    name: '名称',
    enName: '英文名称',
    website: '网址',
    contact: '联系人',
    phone: '手机号码',
    email: '邮箱',
    wechat: '微信号',
    street: '街道',
    provinceId: 'Province',
    cityId: 'City',
    provenanceId: 'Provenance',
    merchantCategoryId: 'Merchant category',
    longitude: '经度',
    latitude: '纬度',
    wineryTour: '提供酒庄游',
    likesCount: '喜欢数',
    miniProgramPath: '小程序路径',
    shareDesc: '分享描述',
    logo: 'Logo',
    province: '省份',
    city: '城市',
    provenance: '产区',
    merchantCategory: '酒庄分类',
    shareImage: '分享图片',
    posterImage: '海报图片',
    introduction: '介绍',
    images: '图片',
  },
  question: {
    content: '内容',
    kind: '类型',
    kinds: {
      single_choice: '单选',
      multiple_choice: '多选',
    },
    position: '优先级',
    enabled: 'Enabled',
    options: 'Options',
  },
  option: {
    content: '内容',
    position: '优先级',
  },
  customPage: {
    title: '标题',
    slug: 'Slug',
    default: '预置页面',
    miniProgramPath: '小程序路径',
    formalCustomPageId: 'Formal custom page',
    canRollbackData: 'Can rollback data',
    configs: '自定义页面',
  },
  activeStorageBlob: {
  },
  actsAsTaggableOnTag: {
    name: '名称',
  },
}
